import { useQueryGrid } from '@gogame/query';

import { loadCategories } from 'scenes/Influencers/InfluencersChannels/sources/categories';

import { CATEGORIES } from './constants';
import { grid } from './queryKeyFactory';

export const useLoadCategories = () => {
  return useQueryGrid(grid(CATEGORIES), (_, { signal }) =>
    loadCategories({}, { signal })
  );
};
